module.exports = __webpack_public_path__ + "static/media/AmericanExpress.49f8db74.svg";